import { render } from "./DataSearch.vue?vue&type=template&id=367af582"
import script from "./DataSearch.vue?vue&type=script&lang=js"
export * from "./DataSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__